import actionTypes from '../webActionTypes';
import GLOBAL from '../../jcolorglobal';

const API_URL = '/AllowanceInvoiceAction.do';


function beginCreateAllowance(payload) {
    return { type: actionTypes.beginCreateAllowance, payload };
}

function recvCreateAllowanceError(payload) {
    return { type: actionTypes.recvCreateAllowanceError, payload };
}


function recvCreateAllowanceResult(payload) {
    return { type: actionTypes.recvCreateAllowanceResult, payload };
}


function createAllowance(payload = {}) {
    return dispatch => {

        dispatch(beginCreateAllowance(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'createAllowanceInvoice');
            if(payload.buyername) {
                formData.append('buyername', payload.buyername);
            }
            if(payload.buyercrn) {
                formData.append('buyercrn', payload.buyercrn);
            }
            if(payload.yearmonth) {
                formData.append('yearmonth', payload.yearmonth);
            }
            if(payload.istarttag) {
                formData.append('istarttag', payload.istarttag);
            }
            if(payload.invoiceNumber) {
                formData.append('invoiceNumber', payload.invoiceNumber);
            }
            if(payload.allowanceNumber) {
                formData.append('allowanceNumber', payload.allowanceNumber);
            }
            if(payload.allowancedate) {
                formData.append('allowancedate', payload.allowancedate);
            }
            if(payload.allowancedate) {
                formData.append('invoicedate', payload.invoicedate);
            }

            for (let index = 0; index < payload.pdtlist.length; index++) {
                const pdt = payload.pdtlist[index];
                formData.append('pdtcounts[]',  pdt.pdtcount);
                formData.append('pdtids[]',  pdt.pdtid);
                formData.append('pdtnames[]',  pdt.pdtname);
                formData.append('pdtprices[]',  pdt.pdtprice);
                formData.append('taxTypes[]', pdt.taxType);
            }
             

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(recvCreateAllowanceResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvCreateAllowanceError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvCreateAllowanceError(error));
                    reject(error);
                });
        });

        return promise;

    };
}

function beginGetAllowanceList(payload) {
    return { type: actionTypes.beginGetAllowanceList, payload };
}

function recvGetAllowanceListError(payload) {
    return { type: actionTypes.recvGetAllowanceListError, payload };
}


function recvGetAllowanceListResult(payload) {
    return { type: actionTypes.recvGetAllowanceListResult, payload };
}


function getAllowanceList(payload = {}) {
    return (dispatch, getState) => {

        dispatch(beginGetAllowanceList(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            const start = payload.start || 0;
            var querykey = '';
            formData.append('op', 'getAllowanceInvoiceList');
            formData.append('start', start);
            formData.append('len', getState().allowance.pageLen || 20);

            if(!isNaN(payload.starttime) && payload.starttime > 0) {
                formData.append('starttime', payload.starttime);
                querykey += payload.starttime;
            }
            if(!isNaN(payload.endtime) && payload.endtime > 0) {
                formData.append('endtime', parseInt(payload.endtime, 10) + 24 * 60 * 60 * 1000);
                querykey += payload.endtime;
            }

            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            }).then(response => {
                    
                if (response.status === 503) {
                    // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    if(result.error) {
                        reject(result.error);
                        return 
                    }

                    // 拆解list result成id list and data map兩組資料
                    let ids = {};
                    let data = {};
                    // eslint-disable-next-line
                    result.list.map((listitem, index) => {
                        const id = listitem.allowancenumber;
                        ids[start+index] = id;
                        data[id] = listitem;

                    });
                    const { totalCount } = result;

                    dispatch(recvGetAllowanceListResult({ids, data, start, totalCount, querykey}));
                    resolve(result);
                }).catch(error => {
                    dispatch(recvGetAllowanceListError(error));
                    reject(error);
                });
            }).catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                dispatch(recvGetAllowanceListError(error));
                reject(error);
            });
        });

        return promise;
    };
}

function beginGetAllowanceInfo(payload) {
    return { type: actionTypes.beginGetAllowanceInfo, payload };
}

function recvGetAllowanceInfoError(payload) {
    return { type: actionTypes.recvGetAllowanceInfoError, payload };
}


function recvGetAllowanceInfoResult(payload) {
    return { type: actionTypes.recvGetAllowanceInfoResult, payload };
}

/**
 * 
 * @param  payload {取得折讓單資訊}
 * @returns 
 */
function getAllowanceInfo(payload = {}) {
    return (dispatch, getState) => {

        dispatch(beginGetAllowanceInfo(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('op', 'getAllowanceInfo');
            formData.append('allowanceNumber', payload.allowancenumber);
            
            GLOBAL.fetchWithCookies(API_URL, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    
                    if (response.status === 503) {
                        // AWS server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }

                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                    
                            dispatch(recvGetAllowanceInfoResult(result));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(recvGetAllowanceInfoError(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(recvGetAllowanceInfoError(error));
                    reject(error);
                });
        });

        return promise;

    };
}

function uploadAllowanceToTurnkeyStarted(payload) {
    return { type: actionTypes.uploadAllowanceToTurnkeyStarted, payload };
}
function uploadAllowanceToTurnkeySuccess(payload) {
    return { type: actionTypes.uploadAllowanceToTurnkeySuccess, payload };
}
function uploadAllowanceToTurnkeyFailed(payload) {
    return { type: actionTypes.uploadAllowanceToTurnkeyFailed, payload };
}
function uploadAllowanceToTurnkey(payload = {}) {
    return dispatch => {

        dispatch(uploadAllowanceToTurnkeyStarted(payload)); // dispatch synced action to update loading status

        const promise = new Promise((resolve, reject) => {

            let form = new FormData();
            form.append('op', 'uploadAllowanceToTurnkey');
            form.append('allowanceNumber', payload.allowanceNumber);

            GLOBAL.fetchWithCookies(API_URL,
                    {
                        method: "POST",
                        body: form
                    }
            )
                .then(response => {
                    
                    if (response.status === 503) {
                        // server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                        reject({
                            error: 'error.503error',
                            message: '伺服器沒有開啟'
                        });

                        return;
                    }
                    response
                        .json()
                        .then(result => {
                            if (!result) {
                                reject();
                                return;
                            }

                            if(result.error) {
                                reject(result.error);
                                return 
                            }

                            dispatch(uploadAllowanceToTurnkeySuccess({result, ...payload}));
                            dispatch(getAllowanceInfo({ allowancenumber: payload.allowanceNumber}));
                            resolve(result);
                        })
                        .catch(error => {
                            dispatch(uploadAllowanceToTurnkeyFailed(error));
                            reject(error);
                        });
                })
                .catch(error => {
                    // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                    dispatch(uploadAllowanceToTurnkeyFailed(error));
                    reject(error);
                });
        });
        return promise;
    };
}

// ------------------------------
// 刪除尚未上傳至turnkey的折讓單
// ------------------------------
function delAllowanceInvoice(payload = {}) {

    const {
        allowanceNumber,   
    } = payload;

    return dispatch => {

        const promise = new Promise((resolve, reject) => {

            let form = new FormData();
            form.append('op', 'delAllowanceInvoice');
            form.append('allowanceNumber', allowanceNumber);

            GLOBAL.fetchWithCookies(API_URL, {
                method: "POST",
                body: form
            }).then(response => {
                    
                if (response.status === 503) {
                    // server正常，apache也存活，但是resin已經被關閉的情況下會出現此錯誤
                    reject({
                        error: 'error.503error',
                        message: '伺服器沒有開啟'
                    });

                    return;
                }

                response.json().then(result => {
                    if (!result) {
                        reject();
                        return;
                    }

                    if(result.error) {
                        reject(result.error);
                        return 
                    }

                    dispatch(delAllowanceInvoiceSuccess({ allowanceNumber: allowanceNumber}));
                    resolve(result);
                }).catch(error => {
                    reject(error);
                });
            })
            .catch(error => {
                // 手機沒有開網路、錯誤的連線網址或是server完全無法連線（包含AWS以及apache都沒有開的狀態)才會出現此錯誤
                reject(error);
            });
        });

        return promise;
    };
}

// ------------------------------
// [成功] 刪除尚未上傳至turnkey的折讓單
// ------------------------------
function delAllowanceInvoiceSuccess(data) {

    const payload = {
        allowanceNumber: data.allowanceNumber,
    };

    return { type: actionTypes.delAllowanceInvoiceSuccess, payload };
}

const allowanceActions = {
    beginCreateAllowance,
    recvCreateAllowanceError,
    recvCreateAllowanceResult,
    createAllowance,
    beginGetAllowanceList,
    recvGetAllowanceListError,
    recvGetAllowanceListResult,
    getAllowanceList,
    beginGetAllowanceInfo,
    recvGetAllowanceInfoError,
    recvGetAllowanceInfoResult,
    getAllowanceInfo,
    uploadAllowanceToTurnkey,
    delAllowanceInvoice, // 刪除尚未上傳至turnkey的折讓單
};

export default allowanceActions;


// WEBPACK FOOTER //
// ./src/actions/creators/allowanceActions.js